import React from "react";


export const OrganizationSvg: React.FC<{
  height?: number;
  width?: number;
  className?: string;
}> = ({ height=75, width=75, className }) => {

  return (
    <>
      <img
        width={width}
        height={height}
        className={className}
        src={"/assets/images/organization.png"}
      />
    </>
  );
};
